import { handleActions } from 'redux-actions'
import { handleStateChange } from '../utils'
import {
  SET_PRODUCT_LIST_STATE,
  SET_PRODUCT_LIST_DATA,
  SET_PRODUCT_LIST_INDEX,
  CLEAR_PRODUCT_LIST_SEARCH
} from '../constants/mallConstant'
import { ListView } from 'antd-mobile-v2'

export let defaultData = {
  pageIndex: 1,
  isLastPage: false,
  list: [],
  dataSource: (new ListView.DataSource({ rowHasChanged: (row1, row2) => row1 !== row2 }))
}

let initState = {
  loading: false,
  invalid: false,
  errorMessage: '',

  keyword: '',
  index: 'all',
  data: {
    // 'index': defaultData
    search: defaultData
  }
}

export let mallProductList = handleActions({
  [SET_PRODUCT_LIST_STATE]: handleStateChange,
  [SET_PRODUCT_LIST_INDEX]: (state, action) => {
    return {
      ...state,
      index: action.payload
    }
  },
  [SET_PRODUCT_LIST_DATA]: (state, action) => {
    let { list, isLastPage, pageNum: pageIndex } = action.payload.data
    let { keyword, index } = action.payload
    let { data } = state
    let dataSource = new ListView.DataSource({ rowHasChanged: (row1, row2) => row1 !== row2 })
    if (pageIndex > 1) {
      list = [...data[index].list, ...list]
    }
    let pendingData = {
      pageIndex,
      isLastPage,
      list,
      dataSource: dataSource.cloneWithRows(list)
    }
    Object.assign(data, { [index]: pendingData })
    return {
      loading: false,
      errorMessage: '',
      keyword,
      index,
      data
    }
  },
  [CLEAR_PRODUCT_LIST_SEARCH]: (state) => {
    let { data, ...newState } = state
    Object.assign(data, { search: defaultData })
    Object.assign(newState, { data })
    return newState
  }
}, initState)
